import { AudioService } from 'src/app/services/audio/audio.service';
import { Component, OnInit, Input } from "@angular/core";
import { Navigator } from "../../menu/navigator";
import { Platform } from "@ionic/angular";
import { InappService } from "src/app/services/inapp/inapp.service";

@Component({
  selector: "app-buy-button",
  templateUrl: "./buy-button.component.html",
  styleUrls: ["./buy-button.component.scss"],
})
export class BuyButtonComponent implements OnInit {
  @Input() size: string = "medium";
  @Input() color: string = "primary";
  @Input() buttonPadding: string = "12px";
  @Input() customButtonClass: string = "custom-button";

  
  @Input() itemInfo: any;
  @Input() buttonText;

  // is_Piggy_Bank:true  is needed for Piggy Bank Purchases

  constructor(private navigator: Navigator,private platfrom:Platform,private Inapp:InappService,private audioService:AudioService) {}

  ngOnInit() {
  
  }
  onButtonClick() {
    this.audioService.playSound("ShopBuy")
    
    if(this.itemInfo.isAuthenticated){

    if(this.platfrom.is('capacitor')){
   
      return this.Inapp.purchase(this.itemInfo)
    }

   
    return this.navigator.navigateTo(
      "CreditCardComponent",
      { customModalClass: "crown-modal", backdropDismiss: true },
      { ...this.itemInfo }
    );}
  }
}
